import BaseService from "@/services/BaseService";

export default class StatService extends BaseService {

    constructor() {
        super();
    }

    async getDeviceStat(devEUI, start = "", stop = "") {
        const response = await fetch(`${this.apiBaseUrl}/devices/${devEUI}/data?from=${stop}&to=${start}`);
        return await response.json();
    }

}